(function () {
  'use strict';

  var DEFAULT_ENDPOINT = 'https://review-feed-nu.vercel.app/api/reviews';
  var BATCH_SIZE = 12;

  function esc(value) {
    return String(value == null ? '' : value)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#039;');
  }

  function number(value) {
    return Number(value || 0).toLocaleString('en-GB');
  }

  function initials(name) {
    var parts = String(name || 'Customer').trim().split(/\s+/).filter(Boolean);
    return (parts.slice(0, 2).map(function (part) { return part.charAt(0); }).join('') || 'C').toUpperCase();
  }

  function relativeTime(value) {
    var time = new Date(value).getTime();
    if (!time) return '';
    var seconds = Math.max(0, Math.floor((Date.now() - time) / 1000));
    if (seconds < 3600) return Math.max(1, Math.floor(seconds / 60)) + ' minutes ago';
    if (seconds < 86400) return Math.floor(seconds / 3600) + ' hours ago';
    if (seconds < 604800) return Math.floor(seconds / 86400) + ' days ago';
    if (seconds < 2629800) return Math.floor(seconds / 604800) + ' weeks ago';
    return new Intl.DateTimeFormat('en-GB', { day: 'numeric', month: 'short', year: 'numeric' }).format(new Date(time));
  }

  function absoluteDate(value) {
    var time = new Date(value).getTime();
    if (!time) return '';
    return new Intl.DateTimeFormat('en-GB', { day: 'numeric', month: 'short', year: 'numeric' }).format(new Date(time));
  }

  function stars(value, modifier) {
    var score = Math.max(0, Math.min(5, Math.round(Number(value || 0) * 2) / 2));
    var cells = '';
    for (var i = 1; i <= 5; i += 1) {
      var fill = Math.max(0, Math.min(1, score - (i - 1)));
      cells += '<span class="ib-review-star" style="--ib-star-fill:' + Math.round(fill * 100) + '%">★</span>';
    }
    return '<span class="ib-review-stars ' + (modifier || '') + '" aria-label="' + score.toFixed(1) + ' out of 5 stars">' + cells + '</span>';
  }

  function reviewCard(review) {
    var meta = [];
    if (review.countryCode) meta.push(esc(review.countryCode));
    if (review.consumerReviewCount) meta.push(esc(number(review.consumerReviewCount) + ' reviews'));
    var tags = [];
    if (review.collectionTag) tags.push('<span class="ib-review-tag">' + esc(review.collectionTag) + '</span>');
    if (review.location && review.location !== 'United Kingdom') tags.push('<span class="ib-review-tag">' + esc(review.location) + '</span>');
    var longText = String(review.text || '').length > 320;

    return '<article class="ib-review-card" data-nosnippet>' +
      '<div class="ib-review-card__top">' + stars(review.stars) + '<time datetime="' + esc(review.createdAt) + '" title="' + esc(absoluteDate(review.createdAt)) + '">' + esc(relativeTime(review.createdAt)) + '</time></div>' +
      '<div class="ib-review-person">' +
        '<span class="ib-review-avatar" aria-hidden="true">' + esc(initials(review.consumer)) + '</span>' +
        '<span><strong>' + esc(review.consumer || 'Customer') + '</strong>' + (meta.length ? '<small>' + meta.join(' · ') + '</small>' : '') + '</span>' +
      '</div>' +
      (review.title ? '<h4>' + esc(review.title) + '</h4>' : '') +
      '<p class="ib-review-copy' + (longText ? ' is-collapsed' : '') + '">' + esc(review.text || '') + '</p>' +
      (longText ? '<button class="ib-review-expand" type="button" data-expand-review aria-expanded="false">See more</button>' : '') +
      '<div class="ib-review-card__footer"><span class="ib-review-tags">' + tags.join('') + '</span>' +
        (review.url ? '<a href="' + esc(review.url) + '" target="_blank" rel="noopener nofollow">View original ↗</a>' : '') +
      '</div>' +
    '</article>';
  }

  function chooseCount(payload, mode) {
    var counts = payload.counts || {};
    if (mode === 'trustpilot') return Number(counts.trustpilot || 0);
    if (mode === 'combined') return Number(counts.combined || 0);
    return Number(counts.combined || counts.trustpilot || 0);
  }

  function filterReviews(root) {
    var query = String(root._ibQuery || '').trim().toLowerCase();
    var star = Number(root._ibStar || 0);
    return (root._ibReviews || []).filter(function (review) {
      if (review.source && review.source !== 'trustpilot') return false;
      if (star && Number(review.stars) !== star) return false;
      if (!query) return true;
      return [review.title, review.text, review.consumer, review.location]
        .join(' ')
        .toLowerCase()
        .indexOf(query) !== -1;
    });
  }

  function sortReviews(reviews, mode) {
    var selected = mode || 'highest';
    return reviews.slice().sort(function (a, b) {
      var ratingDiff = Number(b.stars || 0) - Number(a.stars || 0);
      var dateDiff = new Date(b.createdAt || 0).getTime() - new Date(a.createdAt || 0).getTime();
      if (selected === 'lowest') ratingDiff = -ratingDiff;
      if (selected === 'recent') return dateDiff || (a._ibOriginalIndex - b._ibOriginalIndex);
      return ratingDiff || dateDiff || (a._ibOriginalIndex - b._ibOriginalIndex);
    });
  }

  function sortLabel(mode) {
    if (mode === 'recent') return 'most recent';
    if (mode === 'lowest') return 'lowest rated';
    return 'highest rated';
  }

  function renderList(root) {
    var grid = root.querySelector('[data-ib-review-grid]');
    var more = root.querySelector('[data-ib-review-more]');
    var status = root.querySelector('[data-ib-review-status]');
    var filtered = sortReviews(filterReviews(root), root._ibSort);
    var visible = filtered.slice(0, root._ibVisible || BATCH_SIZE);
    grid.innerHTML = visible.map(reviewCard).join('');
    status.textContent = filtered.length
      ? 'Showing ' + visible.length + ' of ' + filtered.length + ' reviews, ' + sortLabel(root._ibSort)
      : 'No reviews match that search.';
    more.hidden = visible.length >= filtered.length;
    more.textContent = 'Show more reviews';
  }

  function renderSummary(root, payload) {
    var summary = payload.summary || {};
    var meta = root.querySelector('[data-ib-review-summary-meta]');
    var text = root.querySelector('[data-ib-review-summary-text]');
    var themes = root.querySelector('[data-ib-review-themes]');
    var mentions = root.querySelector('[data-ib-review-mentions]');
    if (meta) meta.textContent = summary.meta || 'AI-generated from customer reviews';
    text.textContent = summary.text || 'Read the latest customer experiences, shown as written.';
    themes.innerHTML = (summary.themes || []).map(function (theme) {
      return '<button type="button" class="ib-review-theme" data-review-query="' + esc(theme.query || theme.label || '') + '">' +
        '<strong>' + esc(theme.label || '') + '</strong><span>' + esc(theme.text || '') + '</span>' +
      '</button>';
    }).join('');
    mentions.innerHTML = (summary.mentions || []).map(function (mention) {
      return '<button type="button" data-review-query="' + esc(mention) + '">' + esc(mention) + '</button>';
    }).join('');
  }

  function bind(root) {
    if (root._ibBound) return;
    root._ibBound = true;
    var search = root.querySelector('[data-ib-review-search]');
    var star = root.querySelector('[data-ib-review-star-filter]');
    var sort = root.querySelector('[data-ib-review-sort]');
    var more = root.querySelector('[data-ib-review-more]');

    search.addEventListener('input', function () {
      root._ibQuery = search.value;
      root._ibVisible = BATCH_SIZE;
      renderList(root);
    });
    star.addEventListener('change', function () {
      root._ibStar = star.value;
      root._ibVisible = BATCH_SIZE;
      renderList(root);
    });
    sort.addEventListener('change', function () {
      root._ibSort = sort.value;
      root._ibVisible = BATCH_SIZE;
      renderList(root);
    });
    more.addEventListener('click', function () {
      root._ibVisible += BATCH_SIZE;
      renderList(root);
    });
    root.addEventListener('click', function (event) {
      var queryButton = event.target.closest('[data-review-query]');
      if (queryButton) {
        root._ibQuery = queryButton.getAttribute('data-review-query') || '';
        root._ibVisible = BATCH_SIZE;
        search.value = root._ibQuery;
        renderList(root);
      }
      var expand = event.target.closest('[data-expand-review]');
      if (expand) {
        var copy = expand.parentElement.querySelector('.ib-review-copy');
        var open = expand.getAttribute('aria-expanded') === 'true';
        copy.classList.toggle('is-collapsed', open);
        expand.setAttribute('aria-expanded', String(!open));
        expand.textContent = open ? 'See more' : 'Show less';
      }
    });
  }

  function render(root, payload) {
    var rating = Number(payload.rating && payload.rating.aggregateScore || 4.8);
    var count = chooseCount(payload, root.getAttribute('data-count-mode') || 'combined');
    var reviews = (payload.reviews || []).filter(function (review) { return !review.source || review.source === 'trustpilot'; }).map(function (review, index) {
      var copy = Object.assign({}, review);
      copy._ibOriginalIndex = index;
      return copy;
    });
    root._ibReviews = reviews;
    root._ibVisible = Number(root.getAttribute('data-review-limit') || BATCH_SIZE);
    root._ibQuery = '';
    root._ibStar = 0;
    root._ibSort = 'highest';

    root.querySelector('[data-ib-review-score]').textContent = rating.toFixed(1);
    root.querySelector('[data-ib-review-count]').textContent = number(count);
    root.querySelector('[data-ib-review-head-stars]').innerHTML = stars(rating, 'is-large');
    renderSummary(root, payload);
    bind(root);
    renderList(root);
    root.classList.remove('is-loading');
    root.classList.add('is-ready');
  }

  function fail(root, error) {
    root.classList.remove('is-loading');
    root.setAttribute('data-review-error', error && error.message ? error.message : 'Unknown review error');
    var fallback = root.querySelector('[data-ib-review-fallback]');
    if (fallback) fallback.hidden = false;
  }

  function fetchPayload(url, options) {
    return fetch(url, options).then(function (response) {
      if (!response.ok) throw new Error('Review feed unavailable');
      return response.json();
    });
  }

  function hydrate(root) {
    if (root._ibHydrating) return;
    root._ibHydrating = true;
    var endpoint = root.getAttribute('data-endpoint') || DEFAULT_ENDPOINT;
    var fallbackEndpoint = root.getAttribute('data-fallback-endpoint') || '';
    fetchPayload(endpoint, { credentials: 'omit', mode: 'cors' })
      .then(function (payload) {
        root.setAttribute('data-review-mode', 'live-feed');
        render(root, payload);
      })
      .catch(function (liveError) {
        if (!fallbackEndpoint) {
          fail(root, liveError);
          return;
        }
        fetchPayload(fallbackEndpoint, { credentials: 'same-origin' })
          .then(function (payload) {
            root.setAttribute('data-review-mode', 'theme-last-known-good');
            render(root, payload);
          })
          .catch(function (fallbackError) {
            fail(root, new Error(liveError.message + '; ' + fallbackError.message));
          });
      });
  }

  function init(scope) {
    (scope || document).querySelectorAll('[data-ib-review-service]').forEach(hydrate);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(document); });
  else init(document);
  document.addEventListener('shopify:section:load', function (event) { init(event.target); });
}());
